import React, { useState } from "react";
import { Flex, Input, Button } from "@chakra-ui/react";

export function GoToPage({ totalPages, onGo, isDisabled }) {
  const [value, setValue] = useState("");

  const submit = () => {
    const page = parseInt(value, 10);
    if (!page || page < 1 || page > totalPages) return;
    onGo(page);
    setValue("");
  };

  return (
    <Flex align="center" gap={1}>
      <Input
        type="number"
        min={1}
        max={totalPages}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && submit()}
        placeholder="Page"
        size="sm"
        w="64px"
        borderRadius="md"
        isDisabled={isDisabled || totalPages <= 1}
      />
      <Button
        size="sm"
        variant="outline"
        colorScheme="red"
        onClick={submit}
        isDisabled={isDisabled || totalPages <= 1}
      >
        Go
      </Button>
    </Flex>
  );
}

export default GoToPage;